export default __webpack_public_path__ + "static/media/9.86029e2e.png";